import { useEffect } from 'react';

const usePageMetaTitle = ( title ) => {
    useEffect( () => {
        document.title = title;
        return ()=>{
            document.title = '';
        };
    } , [ title ]);
};

export default usePageMetaTitle;